import { render, staticRenderFns } from "./remediation.vue?vue&type=template&id=1363dc74&scoped=true"
import script from "./remediation.vue?vue&type=script&lang=js"
export * from "./remediation.vue?vue&type=script&lang=js"
import style0 from "./remediation.vue?vue&type=style&index=0&id=1363dc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363dc74",
  null
  
)

export default component.exports